<section
  class="settings-kit-confirm"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="settings-confirm-dialog-title"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="cancel.emit()"
>
  <header class="settings-kit-confirm-header">
    <h2 id="settings-confirm-dialog-title">{{ confirmation.heading }}</h2>
    <button type="button" class="settings-kit-confirm-close" aria-label="Close confirmation" (click)="cancel.emit()">
      <app-icon name="sapphire-close" [size]="20" />
    </button>
  </header>
  <div class="settings-kit-confirm-body">
    <p>{{ confirmation.body }}</p>
  </div>
  <footer class="settings-kit-confirm-footer">
    <button type="button" class="settings-kit-button" cdkFocusInitial (click)="cancel.emit()">Cancel</button>
    <button
      type="button"
      class="settings-kit-button settings-kit-confirm-primary"
      [class.settings-kit-confirm-destructive]="confirmation.destructive"
      (click)="confirm.emit()"
    >
      {{ confirmation.confirmLabel }}
    </button>
  </footer>
</section>
